import { Injectable, signal } from '@angular/core';

/**
 * Carries the resolved email address between the login/MFA screens and the
 * Secure Messaging `forgot-password` / `expired-password` routes in memory
 * only - never via query, localStorage, or sessionStorage.
 */
@Injectable({ providedIn: 'root' })
export class SecureMessagingPasswordResetStateService {
  private readonly emailAddressSignal = signal<string | null>(null);

  readonly emailAddress = this.emailAddressSignal.asReadonly();

  setEmail(emailAddress: string): void {
    this.emailAddressSignal.set(emailAddress);
  }

  /** Returns and clears the one-shot carried email (forgot-password prefill). */
  consumeEmail(): string | null {
    const emailAddress = this.emailAddressSignal();
    this.emailAddressSignal.set(null);
    return emailAddress;
  }

  clearEmail(): void {
    this.emailAddressSignal.set(null);
  }
}
